/*
Defines the custom element <ravel-touch-pad>
*/

import { RavelTouchPad } from './src/RavelTouchPad.js';

customElements.define('ravel-touch-pad', RavelTouchPad);
